import(/* webpackMode: "eager", webpackExports: ["ListingsClient"] */ "/app/fo/src/components/listings/ListingsClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
